var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import artifactHistoryQuery from "../../models/artifact-current-releases.query.graphql";
import styled from "styled-components";
import { ReleaseGroupsTableView } from "../ReleaseGroupsTableView";
import { Spinner, graphql, compose } from "@atlassiansox/microscopekit";
export var MoreButton = styled.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 20px;\n  text-align: center;\n  &:hover {\n    cursor: pointer;\n    text-decoration: underline;\n  }\n"], ["\n  margin: 20px;\n  text-align: center;\n  &:hover {\n    cursor: pointer;\n    text-decoration: underline;\n  }\n"])));
var ArtifactsView = /** @class */ (function (_super) {
    __extends(ArtifactsView, _super);
    function ArtifactsView(props) {
        var _this = _super.call(this, props) || this;
        _this.fetchMoreReleaseGroups = function () {
            _this.setState({ loading: true });
            _this.props.data.fetchMore({
                variables: {
                    pageSize: _this.props.pageSize,
                    page: Math.floor(_this.state.releaseGroups.length / _this.props.pageSize),
                },
                updateQuery: function (prev, _a) {
                    var fetchMoreResult = _a.fetchMoreResult;
                    if (!fetchMoreResult) {
                        return {
                            artifact: null,
                        };
                    }
                    else {
                        return fetchMoreResult;
                    }
                }
            }).then(function (result) {
                if (result.data.artifact === null) {
                    return;
                }
                var releaseGroupsCount = result.data.artifact.currentReleases.totalResults;
                var releaseGroups = _this.state.releaseGroups.concat(result.data.artifact.currentReleases.releases);
                _this.setState({
                    releaseGroupsCount: releaseGroupsCount,
                    releaseGroups: releaseGroups,
                    loading: false,
                });
            });
        };
        var releaseGroups = _this.props.data != null && _this.props.data.artifact != null ? props.data.artifact.currentReleases.releases : [];
        var releaseGroupsCount = _this.props.data != null && _this.props.data.artifact != null ? props.data.artifact.currentReleases.totalResults : 0;
        _this.state = {
            releaseGroups: releaseGroups,
            releaseGroupsCount: releaseGroupsCount,
            loading: releaseGroupsCount === 0,
        };
        return _this;
    }
    ArtifactsView.prototype.componentDidUpdate = function (prevProps) {
        // The last condition, despite seemingly redundant, is required to avoid a setState recursion limit exceeded
        if (this.props.data != null && this.props.data.artifact != null && this.state.releaseGroupsCount === 0) {
            this.setState({
                releaseGroups: this.props.data.artifact.currentReleases.releases,
                releaseGroupsCount: this.props.data.artifact.currentReleases.totalResults,
                loading: false
            });
        }
    };
    ArtifactsView.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            this.state.loading && this.state.releaseGroups.length === 0 ? null :
                React.createElement(ReleaseGroupsTableView, { releaseGroups: this.state.releaseGroups }),
            this.state.loading ?
                React.createElement("div", { style: { position: "relative", margin: "10px", padding: "10px" } },
                    React.createElement(Spinner, { size: "medium" })) : null,
            this.state.releaseGroupsCount > this.state.releaseGroups.length &&
                React.createElement(MoreButton, { onClick: function () { return _this.fetchMoreReleaseGroups(); } },
                    "See ",
                    this.props.pageSize,
                    " more results (",
                    this.state.releaseGroupsCount - this.state.releaseGroups.length,
                    " total)...")));
    };
    return ArtifactsView;
}(React.Component));
export { ArtifactsView };
export var Artifacts = compose(graphql(artifactHistoryQuery))(ArtifactsView);
var templateObject_1;
